<script setup>
import {computed, inject} from "vue";

const props = defineProps({
    nextIndex: Number,
    previousIndex: Number,
    isActiveButton: Boolean,
    inputKey: {
        type:String,
        default: null
    },
    value: {
        type:String,
        default: null
    },
    isTopReturn: Boolean,
    showNextButton: {
        type: Boolean,
        default: true
    },
});
const previousPageLink = computed(() => {
    // 最初のページの場合はトップページに戻る
    if (props.previousIndex === 0) {
        return '/';
    }
   return '/form/' + props.previousIndex;
});
const index = inject('index');
</script>

<template>
    <div id="page-transition" class="uk-margin uk-flex">
        <div class="uk-flex-1">
            <router-link :to="previousPageLink">
                <button class="uk-button uk-button-default uk-border-rounded uk-margin-auto uk-width-auto" @click="$emit('resetInputValue',index)">戻る</button>
            </router-link>
        </div>
        <div class="uk-flex-1">
            <template v-if="isTopReturn">
                <router-link :to="'/'">
                    <button class="uk-button uk-button-primary uk-border-rounded uk-margin-auto uk-display-inline-block uk-width-auto">topに戻る</button>
                </router-link>

            </template>
            <template v-else>
                <template v-if="showNextButton">
                <router-link :to="'/form/' + nextIndex">
                    <button class="uk-button uk-button-primary uk-border-rounded uk-margin-auto uk-display-inline-block uk-width-auto"
                            :disabled="!isActiveButton"
                            @click="$emit('changeIndex', nextIndex, inputKey, value)">進む
                    </button>
                </router-link>
                </template>
            </template>
        </div>
    </div>
</template>

<style scoped>
#page-transition {
    height: var(--page-transition-height);
}

</style>